import { render, staticRenderFns } from "./MyQuestion.vue?vue&type=template&id=428047c1&scoped=true&"
import script from "./MyQuestion.vue?vue&type=script&lang=js&"
export * from "./MyQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MyQuestion.vue?vue&type=style&index=0&id=428047c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428047c1",
  null
  
)

export default component.exports